var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCat101(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#f9f7e1;stroke:#333;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cat_101"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 100,
    height: 100
  }), /*#__PURE__*/React.createElement("path", {
    id: "_101",
    "data-name": 101,
    className: "cls-2",
    d: "M77.69,11.31c-10.35-11.6-35.25-11.7-47.32.2-9.66,9.52-8,23.64-6.62,35.16C26.2,67.24,37.8,97.25,52,97.5c15.75.28,27.25-36.11,29.84-58.1C83.16,28.35,84.16,18.57,77.69,11.31Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCat101);
export default __webpack_public_path__ + "static/media/cat_101.887e66f5ccd0c66f7001f79fda4ec2b3.svg";
export { ForwardRef as ReactComponent };